/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcelTrackingVo } from './ParcelTrackingVo';
import {
    ParcelTrackingVoFromJSON,
    ParcelTrackingVoFromJSONTyped,
    ParcelTrackingVoToJSON,
    ParcelTrackingVoToJSONTyped,
} from './ParcelTrackingVo';

/**
 * 
 * @export
 * @interface OrderBigGoodsVo
 */
export interface OrderBigGoodsVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    id?: number;
    /**
     * 商品行索引
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    rowIndex?: number;
    /**
     * 商品描述  代买，页面上显示在订单号上方
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    goodsDescription?: string;
    /**
     * 商品SKU编码
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    skuCode?: string;
    /**
     * 原产地，来源订单商品 origin
     * 原产地
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    origin?: string;
    /**
     * 是否打印原产地，来源订单商品 originPrint：0 不打印，1 打印
     * 是否打印原产地 0 不打印，1 打印
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    originPrint?: number;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    imgUrl?: string;
    /**
     * 商品链接
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    url?: string;
    /**
     * 通关类目名称
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    ctmsItemName?: string;
    /**
     * 商品通关类目ID
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    ctmsItemId?: number;
    /**
     * HS编码
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    hsCode?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    name?: string;
    /**
     * 商品市场条码
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    marketBarcode?: string;
    /**
     * 采购平台订单号
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    purchasePlatformOrderNo?: string;
    /**
     * 运单号类型
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    trackNoType?: number;
    /**
     * 运单号类型名称
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    trackNoTypeName?: string;
    /**
     * 运单号
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    trackNo?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    color?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    size?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    quantity?: number;
    /**
     * 商品单价
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    unitPrice?: string;
    /**
     * 商品总价
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    totalPrice?: string;
    /**
     * 货位号
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    locationCode?: string;
    /**
     * 区域
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    zoneName?: string;
    /**
     * 原始货位号
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    originLocationCode?: string;
    /**
     * 商品状态名称
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    goodsStatusName?: string;
    /**
     * 商品状态
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    goodsStatus?: number;
    /**
     * 商品编号
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    code?: string;
    /**
     * 商品市场名称
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    marketProNm?: string;
    /**
     * 商品选项名
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    marketOptionName?: string;
    /**
     * 商品备注
     * @type {string}
     * @memberof OrderBigGoodsVo
     */
    remark?: string;
    /**
     * 商品总价（美元）
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    totalPriceUsd?: number;
    /**
     * 最初的代买商品ID
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    proxyBuyPreGoodsId?: number;
    /**
     * 构成
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    constructCount?: number;
    /**
     * 是否样品商品 0 不是 1 是
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    simple?: number;
    /**
     * 已包装火箭订单中，快递件商品实际所在箱子的箱唛号。
     * 快递件商品所在箱唛号，未包装或无装箱关系时为空
     * @type {Array<string>}
     * @memberof OrderBigGoodsVo
     */
    expressBoxMarkNos?: Array<string>;
    /**
     * 商品来源类型 1 普通url下单 2 sku下单 3 库存下单 4 复制购物车
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    sourceType?: number;
    /**
     * 购买类型 1 代买 2 转运 3 返送
     * @type {number}
     * @memberof OrderBigGoodsVo
     */
    buyType?: number;
    /**
     * 无数据id列表
     * @type {Array<number>}
     * @memberof OrderBigGoodsVo
     */
    nodataIdList?: Array<number>;
    /**
     * 库存号列表
     * @type {Array<number>}
     * @memberof OrderBigGoodsVo
     */
    stockIds?: Array<number>;
    /**
     * 商品单跟踪列表
     * @type {Array<ParcelTrackingVo>}
     * @memberof OrderBigGoodsVo
     */
    parcelTrackingVOList?: Array<ParcelTrackingVo>;
    /**
     * 客户端按钮编码列表
     * @type {Array<string>}
     * @memberof OrderBigGoodsVo
     */
    clientButtonCodes?: Array<string>;
    /**
     * 管理端按钮编码列表
     * @type {Array<string>}
     * @memberof OrderBigGoodsVo
     */
    adminButtonCodes?: Array<string>;
    /**
     * 管理端商品状态列表
     * @type {Array<number>}
     * @memberof OrderBigGoodsVo
     */
    adminManualGoodsStatusList?: Array<number>;
}

/**
 * Check if a given object implements the OrderBigGoodsVo interface.
 */
export function instanceOfOrderBigGoodsVo(value: object): value is OrderBigGoodsVo {
    return true;
}

export function OrderBigGoodsVoFromJSON(json: any): OrderBigGoodsVo {
    return OrderBigGoodsVoFromJSONTyped(json, false);
}

export function OrderBigGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderBigGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'rowIndex': json['rowIndex'] == null ? undefined : json['rowIndex'],
        'goodsDescription': json['goodsDescription'] == null ? undefined : json['goodsDescription'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'originPrint': json['originPrint'] == null ? undefined : json['originPrint'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'url': json['url'] == null ? undefined : json['url'],
        'ctmsItemName': json['ctmsItemName'] == null ? undefined : json['ctmsItemName'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'hsCode': json['hsCode'] == null ? undefined : json['hsCode'],
        'name': json['name'] == null ? undefined : json['name'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'purchasePlatformOrderNo': json['purchasePlatformOrderNo'] == null ? undefined : json['purchasePlatformOrderNo'],
        'trackNoType': json['trackNoType'] == null ? undefined : json['trackNoType'],
        'trackNoTypeName': json['trackNoTypeName'] == null ? undefined : json['trackNoTypeName'],
        'trackNo': json['trackNo'] == null ? undefined : json['trackNo'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'locationCode': json['locationCode'] == null ? undefined : json['locationCode'],
        'zoneName': json['zoneName'] == null ? undefined : json['zoneName'],
        'originLocationCode': json['originLocationCode'] == null ? undefined : json['originLocationCode'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
        'goodsStatus': json['goodsStatus'] == null ? undefined : json['goodsStatus'],
        'code': json['code'] == null ? undefined : json['code'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'totalPriceUsd': json['totalPriceUsd'] == null ? undefined : json['totalPriceUsd'],
        'proxyBuyPreGoodsId': json['proxyBuyPreGoodsId'] == null ? undefined : json['proxyBuyPreGoodsId'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'expressBoxMarkNos': json['expressBoxMarkNos'] == null ? undefined : json['expressBoxMarkNos'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'buyType': json['buyType'] == null ? undefined : json['buyType'],
        'nodataIdList': json['nodataIdList'] == null ? undefined : json['nodataIdList'],
        'stockIds': json['stockIds'] == null ? undefined : json['stockIds'],
        'parcelTrackingVOList': json['parcelTrackingVOList'] == null ? undefined : ((json['parcelTrackingVOList'] as Array<any>).map(ParcelTrackingVoFromJSON)),
        'clientButtonCodes': json['clientButtonCodes'] == null ? undefined : json['clientButtonCodes'],
        'adminButtonCodes': json['adminButtonCodes'] == null ? undefined : json['adminButtonCodes'],
        'adminManualGoodsStatusList': json['adminManualGoodsStatusList'] == null ? undefined : json['adminManualGoodsStatusList'],
    };
}

export function OrderBigGoodsVoToJSON(json: any): OrderBigGoodsVo {
    return OrderBigGoodsVoToJSONTyped(json, false);
}

export function OrderBigGoodsVoToJSONTyped(value?: OrderBigGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'rowIndex': value['rowIndex'],
        'goodsDescription': value['goodsDescription'],
        'skuCode': value['skuCode'],
        'origin': value['origin'],
        'originPrint': value['originPrint'],
        'imgUrl': value['imgUrl'],
        'url': value['url'],
        'ctmsItemName': value['ctmsItemName'],
        'ctmsItemId': value['ctmsItemId'],
        'hsCode': value['hsCode'],
        'name': value['name'],
        'marketBarcode': value['marketBarcode'],
        'purchasePlatformOrderNo': value['purchasePlatformOrderNo'],
        'trackNoType': value['trackNoType'],
        'trackNoTypeName': value['trackNoTypeName'],
        'trackNo': value['trackNo'],
        'color': value['color'],
        'size': value['size'],
        'quantity': value['quantity'],
        'unitPrice': value['unitPrice'],
        'totalPrice': value['totalPrice'],
        'locationCode': value['locationCode'],
        'zoneName': value['zoneName'],
        'originLocationCode': value['originLocationCode'],
        'goodsStatusName': value['goodsStatusName'],
        'goodsStatus': value['goodsStatus'],
        'code': value['code'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'remark': value['remark'],
        'totalPriceUsd': value['totalPriceUsd'],
        'proxyBuyPreGoodsId': value['proxyBuyPreGoodsId'],
        'constructCount': value['constructCount'],
        'simple': value['simple'],
        'expressBoxMarkNos': value['expressBoxMarkNos'],
        'sourceType': value['sourceType'],
        'buyType': value['buyType'],
        'nodataIdList': value['nodataIdList'],
        'stockIds': value['stockIds'],
        'parcelTrackingVOList': value['parcelTrackingVOList'] == null ? undefined : ((value['parcelTrackingVOList'] as Array<any>).map(ParcelTrackingVoToJSON)),
        'clientButtonCodes': value['clientButtonCodes'],
        'adminButtonCodes': value['adminButtonCodes'],
        'adminManualGoodsStatusList': value['adminManualGoodsStatusList'],
    };
}

